// extracted by mini-css-extract-plugin
export default {"wrapper":"pD-z","button":"qD-z","alternate":"rD-z","disabled":"sD-z","paymentWarning":"tD-z","fadeIn":"uD-z"};